<template>
  <el-dialog
    :append-to-body="true"
    :before-close="onBeforeClose"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :modal="false"
    :title="titleName"
    :visible.sync="dialogVisible"
    custom-class="common-dialog"
    top="10vh"
    width="500px"
  >
    <div class="tab">
      <div class="tab__content">
        <div class="flex row justify-between items-center label-box__gap">
          <span class="dialog-label">标题</span>
          <el-input
            v-model="title"
            class="flex1"
            placeholder="请输入标题"
            size="small"
          ></el-input>
        </div>
        <div class="flex row justify-between items-center label-box__gap">
          <span class="dialog-label">部门</span>
          <el-input
            v-model="entryDepartment"
            class="flex1"
            placeholder="请输入部门"
            size="small"
          ></el-input>
        </div>
        <div class="flex row justify-between items-center label-box__gap">
          <span class="dialog-label">创建人</span>
          <el-input
            v-model="createUser"
            class="flex1"
            placeholder="请输入创建人"
            size="small"
          ></el-input>
        </div>
        <div class="flex row justify-between items-center label-box__gap">
          <span class="dialog-label">日期</span>
          <el-date-picker
            v-model="currentDate"
            class="flex1"
            placeholder="选择日期"
            size="small"
            type="date"
          ></el-date-picker>
        </div>
        <div class="flex row justify-between items-center label-box__gap">
          <span class="dialog-label">类型</span>
          <el-input
            v-model="category"
            class="flex1"
            placeholder="请输入类型"
            size="small"
          ></el-input>
        </div>
        <div class="flex justify-start">
          <span class="dialog-label">附件</span>
          <el-upload
            ref="upload"
            :auto-upload="false"
            :before-upload="beforeAvatarUpload"
            :file-list="linksList"
            :http-request="uploadFile"
            :limit="1"
            :on-remove="handleRemove"
            action=""
            list-type="picture"
          >
            <div class="flex justify-start">
              <GreenButton
                slot="trigger"
                class="button__default"
                text="图片"
              ></GreenButton>
            </div>
            <div
              slot="tip"
            >只能上传jpg/jpeg/svg/png文件
            </div>
          </el-upload>
        </div>
      </div>
      <div class="tab__footer flex row justify-end items-center">
        <GreenButton
          :options="{
                    borderColor: 'rgba(26,89,184,0.33)',
                    borderRadius: '5px',
                    color: '#1A59B8 !important'
          }"
          class="button__cancel button__gap"
          text="取消"
          @click="cancelClick"
        ></GreenButton>
        <GreenButton
          :loading="createLoading"
          class="button__default"
          loading-text="处理中"
          text="确定"
          @click="onCreateClick"
        ></GreenButton>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import GreenButton from '@/components/buttons/GreenButton'

export default {
  name: 'SouthernEngineeringDialog',
  mixins: [],
  components: {
    GreenButton
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      dialogVisible: false,
      createUser: '',
      title: '',
      entryDepartment: '',
      currentDate: '',
      category: '',
      createLoading: false,
      linksList: [],
      fileData: {},
    }
  },
  computed: {
    titleName() {
      return this.isEdit ? '南方工程简报编辑' : '南方工程简报填报'
    }
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.dialogVisible = true
        this.createUser = ''
        this.title = ''
        this.entryDepartment = ''
        this.currentDate = ''
        this.category = ''
        this.linksList = []
        if (this.isEdit) {
          this.getDataInfo()
        }
      }
    }
  },
  methods: {
    onBeforeClose(done) {
      this.$emit('closeDialog')
      this.clearClick()
      done()
    },

    /**
     * 获取 大型机械管理 数据
     * */
    async getDataInfo() {
      const { success, data } = await this.$http({
        url: this.$api.getQueryProjectNewsDetail,
        params: {
          id: this.id
        }
      })
      if (success) {
        const {
          UserName,
          Title,
          Group,
          CreationDate,
          Category,
          LinkFiles,
        } = data
        this.createUser = UserName === null ? '' : UserName
        this.title = Title === null ? '' : Title
        this.entryDepartment = Group === null ? '' : Group
        this.currentDate = CreationDate.split('T')[0]
        this.category = Category === null ? '' : Category
        this.linksList = [
          ...LinkFiles.reduce((acc, file) => {
            const { ID: id, Name: name, RemotePath: url } = file
            acc.push({
              id,
              name,
              url: `${WEB_CONFIG.BASE_URL}${url}`,
              isServer: true
            })
            return acc
          }, [])
        ]
        this.$refs.upload.uploadFiles = this.linksList
      }
    },
    /**
     * 创建 大型机械管理
     * */
    async onCreateClick() {
      if (this.title === '') {
        this.$message.error('请输入标题')
        return
      }
      if (this.entryDepartment === '') {
        this.$message.error('请输入部门')
        return
      }
      if (this.createUser === '') {
        this.$message.error('请输入创建人')
        return
      }
      if (this.currentDate === '') {
        this.$message.error('请选择日期')
        return
      }
      if (this.category === '') {
        this.$message.error('请输入类型')
        return
      }
      if (this.$refs.upload.uploadFiles.length === 0) {
        this.$message.error('请上传附件')
      }
      else {
        let tempDta = this.fileData
        this.fileData = new FormData()
        await this.$refs.upload.submit()
        await this.uploadChange()
      }
    },
    /**
     *  取消 事件
     * */
    cancelClick() {
      this.$emit('closeDialog')
      this.clearClick()
    },
    /**
     *  清空 事件
     * */
    clearClick() {
      this.createUser = ''
      this.title = ''
      this.entryDepartment = ''
      this.currentDate = ''
      this.category = ''
      this.linksList = []
      this.dialogVisible = false
      this.$refs.upload.clearFiles()
    },
    /**
     * 上传附件之前
     */
    beforeAvatarUpload(file) {
      //      const testing = file.name.substring(file.name.lastIndexOf('.') + 1)
      //      const extension = testing === 'jpg'
      //      const extension1 = testing === 'jpeg'
      //      const extension2 = testing === 'png'
      //      const extension3 = testing === 'svg'
      //      if (!extension && !extension1 && !extension2 && !extension3) {
      //        this.$message.error('只能上传jpg、jpeg、svg与png文件')
      //        return false
      //      }
    },
    /**
     * 上传附件
     */
    async uploadFile(files) {
      const { file } = files
      this.fileData.append('file', file)
    },
    /**
     * 上传 事件
     * */
    async uploadChange() {
      const { raw, isServer } = this.$refs.upload.uploadFiles[0]
      if (!isServer) {
        const testing = raw.name.substring(raw.name.lastIndexOf('.') + 1)
        const extension = testing === 'jpg'
        const extension1 = testing === 'jpeg'
        const extension2 = testing === 'png'
        const extension3 = testing === 'svg'
        if (!extension && !extension1 && !extension2 && !extension3) {
          this.$message.error('只能上传jpg、jpeg、svg与png文件')
          this.$refs.upload.clearFiles()
          return
        }
      }
      this.createLoading = true
      const currentDate = this.$dateFormat(this.currentDate, 'yyyy-MM-dd')
      const newUrl = this.isEdit ? this.$api.goUpdateProjectNews : this.$api.goAddProjectNews
      if (this.isEdit) {
        this.fileData.append('ID', this.id)
      }
      this.fileData.append('Title', this.title)
      this.fileData.append('UserName', this.createUser)
      this.fileData.append('Group', this.entryDepartment)
      this.fileData.append('CreationDate', currentDate)
      this.fileData.append('Category', this.category)
      const { success } = await this.$http({
        url: newUrl,
        method: 'POST',
        data: this.fileData
      })
      if (success) {
        this.$emit('refresh')
        this.$message.success(this.isEdit ? '编辑成功' : '填报成功')
        this.clearClick()
      }
      else {
        this.$refs.upload.clearFiles()
      }
      this.createLoading = false
    },
    /**
     * 移除文件
     * */
    handleRemove(file, fileList) {
      const { id, isServer } = file
      if (isServer) {
        this.deleteFileChange(id)
      }
    },
    /**
     * 删除服务器的文件
     * */
    async deleteFileChange(ID) {
      await this.$http({
        url: this.$api.goDeleteDocumentVersionsByVersionIDs,
        params: {
          ids: ID
        }
      })
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
$tabsDefaultColor: #FFFFFF;
$tabsActiveColor: #42DEFD;
$borderColor: rgba(3, 175, 252, 0.66);

.tab {
  height: 480px;

  &__content {
    overflow: auto;
    height: calc(100% - 74px);
  }

  &__footer {
    height: 59px;
    margin: 1em -2.4em 0;
    padding: 0 2em;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    background-color: #FFFFFF;
  }
}

//dialog
::v-deep.el-dialog__wrapper {
  background-color: rgba(0, 0, 0, .5);
}

::v-deep .el-dialog__title {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 1px;
  color: rgba(0, 0, 0, 0.85);
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: rgba(0, 0, 0, 0.02) !important;
}

::v-deep .el-dialog__body {
  padding: 30px 34px 0;
}

//dialog
::v-deep .el-tabs {
  margin-bottom: 1em;

  &__header {
    margin: 0;
  }

  &__nav-wrap::after {
    background-color: transparent;
  }

  &__item {
    font-size: 14px;
    font-weight: 400;
    line-height: 30px;
    height: 31px;
    padding: 0 1em;
    color: $tabsDefaultColor;

    &.is-active {
      color: $tabsActiveColor;
    }
  }

  &__active-bar {
    color: $tabsActiveColor;
  }

  &__content {
    display: none;
  }
}

::v-deep .el-upload-list__item-name {
  max-width: 180px;
}
</style>
